import * as svg from "../../../assets/import-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const ImportIcon = iconBuilder(svg, "ImportIcon", "0 0 20 21");
